import * as React from 'react';
import { IAIcon } from '../icon/Icon';
import * as styles from './smallMenu.css'


export interface SmallMenuItem {
  translation: string;
  actionName: string;
  icon?: string;
  iconUrl?: string;
}

export interface IHeaderMenuProps {
  menuItems?: SmallMenuItem[];
  highlightColor: string;
  iconColor: string;
  styles?: React.CSSProperties;
  togglerSize?: number;
  isTogglerRotated?: boolean;
  isOverlayed?: boolean;
  onMenuItemClick?: (title: string) => void;
}


export interface IHeaderMenuState {
  isMenuOpen: boolean;
}


export class IASmallMenu extends React.Component<IHeaderMenuProps, IHeaderMenuState> {
  private menuRef: React.RefObject<HTMLDivElement>
  constructor(props: IHeaderMenuProps) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
    this.menuRef = React.createRef();
    this.handleClick = this.handleClick.bind(this);
  }

  private handleClick(event: Event) {
    if (this.menuRef && this.menuRef.current && !this.menuRef.current.contains(event.target as Node)) {
      if (this.state.isMenuOpen) {
        this.setState({ isMenuOpen: false })
      }
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  public render(): JSX.Element {
    return (
      <div
        ref={this.menuRef}
        style={this.props.styles}
      >
        <div
          className="IA_OnFocusOutline_outer"
          style={{
            marginLeft: 5,
            opacity: this.props.isOverlayed ? 0.3 : 1,
            cursor: this.props.isOverlayed ? "default" : "pointer",
          }}
        >
          <IAIcon
            title="Show Action"
            size={this.props.togglerSize || 22}
            onClick={() => this.setState({ isMenuOpen: !this.state.isMenuOpen })}
            disableTabKey
            color={this.props.highlightColor ?? '#000'}
            style={{ transform: this.props.isTogglerRotated ? 'rotate(90deg)' : '' }}
          />
        </div>

        {this.state.isMenuOpen &&
          <ul className={styles.IA_smallMenu} >
            {this.props.menuItems.map((item) => (
              <li key={item.translation}
                className={`IA_OnFocusOutline_outer ${styles.IA_menuItem}`}
                onClick={() => {
                  this.props.onMenuItemClick(item.actionName)
                  this.setState({ isMenuOpen: false })
                }}>
                <IAIcon
                  title={item.icon}
                  url={item.iconUrl}
                  size={20}
                  color={this.props.iconColor ?? '#000'}
                  style={{ marginRight: 8, lineHeight: "0px" }}
                />
                <span style={{
                  color: "#333333"
                }}>
                  {item.translation}
                </span>
              </li>
            ))}
          </ul>
        }
      </div>
    )
  }
}